import { each } from 'lodash/fp';
import { DATE_LEGEND_HEIGHT } from '../../constants';
import { drawSpaceRectangle, drawDayRectangle, drawType, getSpaceBackground } from '../../utils/drawUtils';
import ResourceUse from './resourceUse';

export default function ResourceUseCanvas(fromTextCache: $TSFixMe, getBgColor: $TSFixMe, companionExtent: $TSFixMe) {
    const resourceUse = ResourceUse(fromTextCache, companionExtent);
    return {
        render({
            ctx,
            xAxis,
            yAxis,
            canvasWidth,
            canvasHeight,
            scale,
            days,
            resources,
            resourceCategoryTypes,
            resourceUses,
            selectedResourceUse,
            highlightedSpaces,
            withLines,
            viewport,
            resourceLegendWidth,
            timelineServiceId,
            timeUnit,
        }: $TSFixMe) {
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);

            each((day: number) => {
                const startX = xAxis(day);
                const endX = xAxis(day + 1);
                drawDayRectangle(ctx, startX, endX - startX, canvasHeight, getBgColor(day, timeUnit));
            })(days);

            each((resource) => {
                if ((resource as $TSFixMe).isLeaf) {
                    const background = getSpaceBackground(resource, highlightedSpaces);
                    drawSpaceRectangle(
                        ctx,
                        0,
                        canvasWidth,
                        (yAxis((resource as $TSFixMe).minY) as number) + DATE_LEGEND_HEIGHT,
                        (yAxis((resource as $TSFixMe).maxY) as number) + DATE_LEGEND_HEIGHT,
                        withLines,
                        background,
                        undefined
                    );
                }
            })(resources);

            each((type) =>
                drawType({
                    ctx,
                    yAxis,
                    height: canvasHeight,
                    type,
                    width: canvasWidth,
                    isHighlighted: false,
                    withLabel: false,
                })
            )(resourceCategoryTypes);

            resourceUse.render({
                ctx,
                xAxis,
                yAxis,
                scale,
                viewport,
                resourceLegendWidth,
                selectedResourceUse,
                uses: resourceUses,
                timelineServiceId,
            });
        },
    };
}
